import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import WhatsAppBubble from "@/components/WhatsAppBubble";
import LandingPage from "@/pages/LandingPage";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import CoursesPage from "@/pages/CoursesPage";
import CourseDetailPage from "@/pages/CourseDetailPage";
import TestTakingPage from "@/pages/TestTakingPage";
import ResultPage from "@/pages/ResultPage";
import ResultsListPage from "@/pages/ResultsListPage";
import DashboardPage from "@/pages/DashboardPage";
import LessonPage from "@/pages/LessonPage";
import AdminPage from "@/pages/AdminPage";
import StudyAbroadPage from "@/pages/StudyAbroadPage";
import TuitionsPage from "@/pages/TuitionsPage";
import ResourcesPage from "@/pages/ResourcesPage";
import PricingPage, { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PricingPage";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/courses" element={<CoursesPage />} />
                        <Route path="/courses/:courseId" element={<CourseDetailPage />} />
                        <Route path="/courses/:courseId/lesson" element={<ProtectedRoute><LessonPage /></ProtectedRoute>} />
                        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
                        <Route path="/pricing" element={<PricingPage />} />
                        <Route path="/study-abroad" element={<StudyAbroadPage />} />
                        <Route path="/tuitions" element={<TuitionsPage />} />
                        <Route path="/resources" element={<ResourcesPage />} />
                        <Route path="/resources/:subjectCode" element={<ResourcesPage />} />
                        <Route path="/payment/success" element={<PaymentSuccessPage />} />
                        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
                        <Route path="/tests/:testId" element={<ProtectedRoute><TestTakingPage /></ProtectedRoute>} />
                        <Route path="/results" element={<ProtectedRoute><ResultsListPage /></ProtectedRoute>} />
                        <Route path="/results/:resultId" element={<ProtectedRoute><ResultPage /></ProtectedRoute>} />
                    </Routes>
                    <WhatsAppBubble />
                </BrowserRouter>
                <Toaster position="top-center" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
